import { useState } from "react";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import MonthCalendarGrid, { buildMonthDays } from "./MonthCalendarGrid";
import useLockBodyScroll from "../../../hooks/useLockBodyScroll";
import "./calendarMonthPopup.css";

// Mobile-only "jump to month" popup — opened by tapping the Calendar screen's title in
// MobileHeader. Reuses MonthCalendarGrid (the same month-grid NewAppointmentFlow's date step
// uses) so this doesn't become a second calendar implementation; every day is selectable here
// (no `isSelectableDay` predicate passed), unlike the booking flow which restricts to bookable
// future slots.
const CalendarMonthPopup = ({ selectedDate, onSelectDate, onClose }) => {
  const [viewMonth, setViewMonth] = useState(() => moment(selectedDate));

  useLockBodyScroll();

  const monthDays = buildMonthDays(viewMonth);
  const today = moment().startOf("day");

  return (
    <div
      className="hf-cmp-overlay"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="hf-cmp-card">
        <div className="hf-cmp-header-row">
          <IconButton
            className="hf-cmp-close"
            aria-label="Zatvori"
            onClick={onClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>

        <MonthCalendarGrid
          viewMonth={viewMonth}
          onPrevMonth={() => setViewMonth((m) => m.clone().subtract(1, "month"))}
          onNextMonth={() => setViewMonth((m) => m.clone().add(1, "month"))}
          monthDays={monthDays}
          today={today}
          selectedDate={moment(selectedDate)}
          onSelectDay={(day) => {
            onSelectDate(day.toDate());
            onClose();
          }}
        />
      </div>
    </div>
  );
};

export default CalendarMonthPopup;
